import { Box, Typography } from '@mui/material'
import { FC } from 'react'

export const ContainerHeader: FC = () => {
  return (
    <Box>
      <Typography
        fontSize={{ xs: '32px', md: '40px' }}
        fontWeight={700}
        color="text.primary"
        textAlign="center"
      >
        Manual Upload
      </Typography>

      <Typography
        fontSize={{ xs: '14px', md: '16px' }}
        fontWeight={500}
        color="#475569"
        textAlign="center"
        maxWidth="600px"
        sx={{ mt: { xs: 2, md: 3 }, mx: 'auto' }}
      >
        Match the color on the strip to the closest results for each attributes. When done, submit
        for analysis
      </Typography>
    </Box>
  )
}
